import React from "react";
import { Button, Tabs, message, Modal, Row, Col } from "antd";
import MiCompAPI from '../../util/api';
import TableWrapper from "../elements/TableWrapper";
import { withRouter } from 'react-router-dom';
import moment from "moment";
import { Link } from 'react-router-dom';

import NiprFeeRequest from "./NIPR/NiprFeeRequest";
const { TabPane } = Tabs;

class LicensesDocuments extends React.Component {


  constructor(props) {

    super(props);
    
    this.tableButtons = [];
    this.state =
    {
      isLoading: this.props.isLoading,
      defaultActiveKey: "1",
      niprfeerequest: null,
      rowdata: null,
      applications: [],
      reports:[]

    }
    this.APPLICATIONS_COLUMNS = [
      {
        title: 'NIPR',
        dataIndex: 'nipr_trans',
        sorter: (a, b) => a.nipr_trans.localeCompare(b.nipr_trans),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'License',
        dataIndex: 'license',
        sorter: (a, b) => a.license.localeCompare(b.license),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'LOA',
        dataIndex: 'loa',
        sorter: (a, b) => a.loa.localeCompare(b.loa),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Transaction Type',
        dataIndex: 'eligibility_type',
        sorter: (a, b) => a.eligibility_type.localeCompare(b.eligibility_type),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'State',
        dataIndex: 'state',
        sorter: (a, b) => a.state.localeCompare(b.state),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Date',
        dataIndex: 'dateStamp',
        render: (text, record) =>
          record["dateStamp"] !== null && record["dateStamp"] !== ""
            ? moment(record["dateStamp"]).format("MM/DD/YYYY")
            : ""
      }, {
        title: 'Payment Status',
        dataIndex: 'payment_status',       
      }, {
        title: 'Action',
        render: (text, record) =>parseFloat(record.state_fee) + parseFloat(record.trans_fee) + parseFloat(record.process_fee)>0&&record.payment_status!=="completed"?
         <Button type="primary" onClick={() => this.props.history.push(
          {
            pathname: '/payment',
            state: record
          })
        }>Pay</Button>:"",

      }
    ];
    this.LICENSE_COLUMNS = [
      {
        title: 'LOA',
        dataIndex: 'loa',
        sorter: (a, b) => a.loa.localeCompare(b.loa),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'License Class',
        dataIndex: 'license_class',
        sorter: (a, b) => a.license_class.localeCompare(b.license_class),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'License Number',
        dataIndex: 'license_no',
        sorter: (a, b) => a.license_no.localeCompare(b.license_no),
        sortDirections: ["descend", "ascend"]
      }, {
        title: "License Status",
        dataIndex: "status",
        render: (text, record) => record["status"] === 'Approved' ? <p style={{ color: '#3fb53c', marginBottom: '-5px' }}>{record["status"]}</p> : record["status"] === 'Rejected' ? <p style={{ color: '#d62412', marginBottom: '-5px' }}>{record["status"]}</p> : <p style={{ color: '#fdb47f', marginBottom: '-5px' }}>{record["status"]}</p>,
        sorter: (a, b) => a.status.localeCompare(b.status),
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'License State',
        dataIndex: 'license_state_name',
        sorter: (a, b) => a.license_state_name.localeCompare(b.license_state_name),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Status Date',
        dataIndex: 'status_date',
        sorter: (a, b) => new Date(a.status_date) - new Date(b.status_date),
        sortDirections: ["descend", "ascend"]
      }


    ];
    this.DOCUMENT_COLUMNS = [
      {
        title: 'Document Type',
        dataIndex: 'document_type_name',
        sorter: (a, b) => a.document_type_name.localeCompare(b.document_type_name),
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Document Status',
        dataIndex: 'status',
        render: (text, record) => record["status"] === 'Approved' ? <p style={{ color: '#3fb53c', marginBottom: '-5px' }}>{record["status"]}</p> : record["status"] === 'Rejected' ? <p style={{ color: '#d62412', marginBottom: '-5px' }}>{record["status"]}</p> : <p style={{ color: '#fdb47f', marginBottom: '-5px' }}>{record["status"]}</p>,
        sorter: (a, b) => a.status.localeCompare(b.status),
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Effective Date',
        dataIndex: 'effective_date',
        render: (text, record) =>
          record["effective_date"] !== null && record["effective_date"] !== ""
            ? moment(record["effective_date"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) => new Date(a.effective_date) - new Date(b.effective_date),
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Termination Date',
        dataIndex: 'termination_date',
        render: (text, record) =>
          record["termination_date"] !== null && record["termination_date"] !== ""
            ? moment(record["termination_date"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) => new Date(a.termination_date) - new Date(b.termination_date),
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Renewal Date',
        dataIndex: 'renewal_date',
        render: (text, record) =>
          record["renewal_date"] !== null && record["renewal_date"] !== ""
            ? moment(record["renewal_date"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) => new Date(a.renewal_date) - new Date(b.renewal_date),
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Submission Date',
        dataIndex: 'submit_date',
        render: (text, record) =>
          record["submit_date"] !== null && record["submit_date"] !== ""
            ? moment(record["submit_date"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) => new Date(a.submit_date) - new Date(b.submit_date),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Approval Date',
        dataIndex: 'date_approved',
        render: (text, record) =>
          record["date_approved"] !== null && record["date_approved"] !== ""
            ? moment(record["date_approved"]).format("MM/DD/YYYY")
            : "",
        sorter: (a, b) => new Date(a.date_approved) - new Date(b.date_approved),
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Action',
        dataIndex: 'url',
        width: 50,
        render: (text, record) => {
          return (

            <div style={{ display: 'flex' }} >
              {record['submit_date'] !== null ?
                <i style={{ marginRight: '0px !important', marginTop: '10px' }} onClick={() => window.open(record.document_path, "_blank")} className="fa fa-eye fa-b" /> : ""}

            </div>

          );
        },
      }];
      this.REPORT_COLUMNS = [
        {
          title: 'Report Name',
          dataIndex: 'report_Name',
          sorter: (a, b) => a.report_Name.localeCompare(b.report_Name),
          sortDirections: ["descend", "ascend"],
          render: (text, record) => {return <Link onClick={()=>{
            window.open(record.unq_Document_Name, "_blank")
          }}>{text}</Link>},
        }, {
          title: 'Uploaded  On',
          dataIndex: 'uploaded_On',
          render: (text, record) =>
            record["uploaded_On"] !== null && record["uploaded_On"] !== ""
              ? moment(record["uploaded_On"]).format("MM/DD/YYYY")
              : "",
          sorter: (a, b) => new Date(a.uploaded_On) - new Date(b.uploaded_On),
          sortDirections: ["descend", "ascend"]
        },{
          title: 'Uploaded  By',
          dataIndex: 'carrier_Name',
          dataIndex: 'carrier_Name',
          sorter: (a, b) => a.carrier_Name.localeCompare(b.carrier_Name),
          sortDirections: ["descend", "ascend"]
        }];
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount = () => {
    const { decodedToken,Permissions } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    if (role === "broker"&&(Permissions[0].subscription_Type==="Standard"||Permissions[0].subscription_Type==="Premium")) {
      this.tableButtons.push({
        buttonType: "primary",
        content: "Apply",
        clickHandler: () => {
          this.props.history.push('/eligibility')
        },
      });
      // this.LICENSE_COLUMNS.push({
      //   title: "Action",
      //   render: (text, record) => <Button type="primary" onClick={() => this.niperexternal(record)}>Renewal</Button>,

      // });
    }
    this.Get_Application_Response();
    this.GetAllUserReports();
  };

  niperexternal = (value) => {
    this.api.invoke(
      "NIPR_External",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {

            this.setState({
              niprfeerequest: data.data,
              rowdata: value,
              isLoading: false,
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }, { etype: value.rstatus === "R" ? "RLR" : "NRR", rtype: 'Fee Request', res_state: value.license_state_abbr, lname: this.props.lname, license_code: value.license_code, loa_code: [value.loa_code] }
    );
  }
  Get_Application_Response = () => {
    this.api.invoke(
      "Get_Application_Response",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {

            this.setState({
              applications: data.data,
              isLoading: false,
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  }
 GetAllUserReports=()=>{
  const { decodedToken } = this.props.userPermandMasters;
  var role = decodedToken.UserRoleName;

  if(role === "carrier"){
    this.api.invoke(
      "GetAllUserReportsById/"+this.props.User_Id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
  
            this.setState({
              reports: data.data,
              isLoading: false,
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  }else{
    this.api.invoke(
      "GetAllUserReports",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
  
            this.setState({
              reports: data.data,
              isLoading: false,
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  }
  
 } 

  render() {
    const { decodedToken,Permissions } = this.props.userPermandMasters;
    
    var role = decodedToken.UserRoleName;
    return (
      <div className="mi_main1" style={{marginLeft:"-1px",marginRight:"-1px"}}>
        {this.state.niprfeerequest ? <Modal visible={true}
        > <NiprFeeRequest loas={[this.state.rowdata.loa]} niprfeerequest={this.state.niprfeerequest} closeDrawerHandler={() => { this.setState({ niprfeerequest: null }) }} /></Modal> : null}
        <Tabs style={{ padding: '0px 10px' }} defaultActiveKey={this.state.defaultActiveKey}>

          <TabPane tab={<span >Documents</span>} key="1" >
            <div  >
              <TableWrapper rowKey="id"
                columns={this.DOCUMENT_COLUMNS}
                data={this.props.documents}
                loading={this.state.isLoading}
                title="Documents"
                search={true}
              />
            </div>
          </TabPane>
          <TabPane tab={<span>Licenses</span>} key="2">
            <div >
              <TableWrapper rowKey="id"
                columns={this.LICENSE_COLUMNS}
                data={this.props.licenses}
                loading={this.state.isLoading}
                title="Licenses"
                buttons={this.tableButtons}
                search={true}

              />
              {role === "broker"&&(Permissions[0].subscription_Type==="Standard"||Permissions[0].subscription_Type==="Premium") ?
                <TableWrapper rowKey="id"
                  columns={this.APPLICATIONS_COLUMNS}
                  data={this.state.applications}
                  loading={this.state.isLoading}
                  title="Applications"
                  search={true}
                  expandedRowRender={(record) => {

                    return <>
                      <div className="mi_main" >
                        <Row span={24}>
                          <Col md={6} sm={24}>
                            <p className="mi_name">Assumed State Fee</p>
                            <p className="mi_value">{record ? "$" + record.assumed_state_fee : 'none'}</p>
                          </Col>
                          <Col md={6} sm={24}>
                            <p className="mi_name">Process Fee</p>
                            <p className="mi_value">{record ? "$" + record.process_fee : 'none'}</p>
                          </Col>
                          <Col md={6} sm={24}>
                            <p className="mi_name">State Fee</p>
                            <p className="mi_value">{record && record.state_fee ? "$" + record.state_fee : 'none'}</p>
                          </Col>
                          <Col md={6} sm={24}>
                            <p className="mi_name">Transaction Fee</p>
                            <p className="mi_value">{record && record.trans_fee ? "$" + record.trans_fee : 'none'}</p>
                          </Col>
                          <Col md={6} sm={24}>
                            <p className="mi_name">Customer Batch</p>
                            <p className="mi_value">{record && record.cust_batch ? record.cust_batch : 'none'}</p>
                          </Col>
                          <Col md={6} sm={24}>
                            <p className="mi_name">Customer Transaction</p>
                            <p className="mi_value">{record && record.cust_trans ? record.cust_trans : 'none'}</p>
                          </Col>
                          <Col md={6} sm={24}>
                            <p className="mi_name">Transaction Status</p>
                            <p className="mi_value">{record ? (record.nipr_status === "AV" ? "Awaiting State validation"
                              : (record.nipr_status === "HT" ? "Holding Tank" : (record.nipr_status === "PC" ? "Processing Complete" : "Under State review"))) : 'none'}</p>
                          </Col>
                        </Row>
                      </div>
                      {record.nIPR_Application_ResponseDtos.find(x => x.action_Required === "Y") ?
                        <div className="mi_main" >
                          <Row span={24}>
                            <Col span={15}>
                              <p className='mi_title' style={{ color: '#fd828d' }}>Action Required</p>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={24}>
                              {record.nIPR_Application_ResponseDtos.filter(x => x.action_Required === "Y").map(x => {
                                return <p style={{ fontSize: '15px', background: '#9982821f', padding: '10px' }} > {x.comment_Code + ") " + x.comments}</p>
                              })}

                            </Col>
                          </Row>
                        </div> : ""}
                      {record.nIPR_Application_ResponseDtos.find(x => x.action_Required === "N") ?
                        <div className="mi_main" >
                          <Row span={24}>
                            <Col span={15}>
                              <p className='mi_title' style={{ color: '#fd828d' }}>No Action Required</p>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={24}>
                              {record.nIPR_Application_ResponseDtos.filter(x => x.action_Required === "N").map(x => {
                                return <p style={{ fontSize: '15px', background: '#9982821f', padding: '10px' }} > {x.comment_Code + ") " + x.comments}</p>
                              })}

                            </Col>
                          </Row>
                        </div> : ""} </>
                  }}

                /> : ""}
            </div>
          </TabPane>
          <TabPane tab={<span >Reports</span>} key="3" >
            <div  >
              <TableWrapper rowKey="id"
                columns={this.REPORT_COLUMNS}
                data={this.state.reports}
                loading={this.state.isLoading}
                title="Reports"
                search={true}
              />
            </div>
          </TabPane>
        </Tabs>

      </div>

    );
  }
}
export default withRouter(LicensesDocuments);
